import axios from 'axios'
import router from './../../../router'
import {Errors, Form} from './../../../components/validations/forms.js'

const namespaced = true;

const state = {
  lang: 'en',
  rtl: false,
  countryMain: {countryMain: 1},
  countriesList: [
    {id:1, name: 'Saudi Arabia'},
    {id:19, name: 'Bahrain'},
  ],
  countriesListArabic: [
    {id:1, name: 'المملكة العربية السعودية'},
    {id:19, name: 'البحرين'},
  ],
  cities: [],
  citiesKSA: [],
  citiesBahrain: [],
  countries: [],
  nationalities: [],
  countryCodes: [
    {
      id: 966,
      name: 'Saudi Arabia:    +966',
    },
    {
      id: 973,
      name: 'Bahrain:    +973',
    },
  ],
  gender: [
    {
      id: 1,
      name: 'Male - الذكر',
    },
    {
      id: 2,
      name: 'Female - أنثى',
    },
  ],
  languages: [
    {
      id: 1,
      name: 'English',
    },
    {
      id: 2,
      name: 'Arabic - العربية',
    },
  ],
  maritalStatus: [
    {
      id: 1,
      name: 'Single - أعزب',
    },
    {
      id: 2,
      name: 'Married - متزوج/ة',
    },
    {
      id: 3,
      name: 'Divorced - مطلق/ة',
    },
    {
      id: 4,
      name: 'Widowed - ارمل/ة',
    },
  ]

};

const getters = {
  getLang (state) {
    return state.lang
  },
  getRTL (state) {
    return state.rtl
  },
  getCities (state) {
    return state.cities
  },
  getCitiesKSA (state) {
    return state.citiesKSA
  },
  getCitiesBahrain (state) {
    return state.citiesBahrain
  },
  getCountries (state) {
    return state.countries
  },
  getCountriesList (state) {
    return state.countriesList
  },
  getCountriesListArabic (state) {
    return state.countriesListArabic
  },
  getCountryMain (state) {
    return state.countryMain.countryMain
  },
  getCountryCodes (state) {
    return state.countryCodes
  },
  getNationalities (state) {
    return state.nationalities
  },
  getGender (state) {
    return state.gender
  },
  getMaritalStatus (state) {
    return state.maritalStatus
  },
  getLanguages (state) {
    return state.languages
  },
};

const mutations = {
  setLang (state, payload) {
    state.lang = payload
  },
  setRTL (state, payload) {
    state.rtl = payload
  },
  setCities (state, payload) {
    state.cities = payload
  },
  setCitiesKSA (state, payload) {
    state.citiesKSA = payload
  },
  setCitiesBahrain (state, payload) {
    state.citiesBahrain = payload
  },
  setCountries (state, payload) {
    state.countries = payload
  },
  setCountryMain (state, payload) {
    state.countryMain = payload;
  },
  setNationalities (state, payload) {
    state.nationalities = payload
  },
};


const actions = {
  setLanguage ({commit, dispatch}, payload) {
    commit('setLang', payload.language);
    if(payload.rtl === 0){commit('setRTL', false);}
    if(payload.rtl === 1){commit('setRTL', true);}
  },
  setCountryMain ({commit, dispatch}, payload) {
    commit('setCountryMain', payload);
  },

  fetchCities ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/city')
        .then(res => {
          commit('setCities', res.data.data)
          console.log('fetchCities - Cities Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },
  fetchCitiesKSA ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/city?country=1')
          .then(res => {
            commit('setCitiesKSA', res.data.data)
            console.log('fetchCitiesKSA - Cities Fetched.');
            resolve(res.data.data);})
          .catch(error => {reject(error.response);})
    })
  },
  fetchCitiesBahrain ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/city?country=19')
          .then(res => {
            commit('setCitiesBahrain', res.data.data)
            console.log('fetchCitiesBahrain - Cities Fetched.');
            resolve(res.data.data);})
          .catch(error => {reject(error.response);})
    })
  },

  fetchCountries ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/country')
        .then(res => {
          commit('setCountries', res.data.data)
          console.log('fetchCountries - Countries Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },


  fetchNationalities ({commit, dispatch}) {
    return new Promise((resolve, reject) => {
      axios.get('/api/nationality')
        .then(res => {
          commit('setNationalities', res.data.data)
          console.log('fetchNationalities - fetchNationalities Fetched.');
          resolve(res.data.data);})
        .catch(error => {reject(error.response);})
    })
  },


  // TODO: Create Function To Get Company Settings


};

export default {
  namespaced,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/general/environment.js